import {
  Box,
  Divider,
  Flex,
  HStack,
  Text,
  VStack,
  Img,
  useBreakpointValue,
  Link,
} from "@chakra-ui/react";
import React, { useState } from "react";
import OnFiLogo from "../../assets/images/home/Group 3.webp";
const Footer = () => {
  const [isHovered1, setIsHovered1] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  const [isHovered3, setIsHovered3] = useState(false);
  const [isHovered4, setIsHovered4] = useState(false);
  const [isHovered5, setIsHovered5] = useState(false);
  const isXLScreen = useBreakpointValue({ base: false, xl: true });
  const [activeItem, setActiveItem] = useState("");

  const handleItemClick = (item) => {
    setActiveItem(item);
  };

  function navigateOnClick(url) {
    return function () {
      window.open(url, "_blank");
    };
  }

  return (
    <Box width={{ base: "auto", xl: "100%" }}>
      {/* orange-border */}
      <Box border="5px solid #FD8534"></Box>
      <Box
        className={isXLScreen ? "container" : "container-responsive"}
        paddingTop={{ base: "50px", xl: "90px" }}
      >
        {/* logo-text */}
        <Box>
          <Link href="/">
            <Img src={OnFiLogo} />
          </Link>
        </Box>
        {/* ul-lis */}
        <Flex
          paddingTop="72px"
          justifyContent={{ base: "start", xl: "space-between" }}
          flexDirection={{ base: "column", xl: "row" }}
        >
          {/* li-1 */}
          <Box>
            <Text
              cursor="pointer"
              color=" #FD8534"
              fontSize="16px"
              fontStyle="normal"
              fontWeight="500"
              lineHeight="normal"
            >
              Company
            </Text>
            <VStack
              spacing="10px"
              alignItems="start"
              paddingTop="27px"
              paddingBottom={{ base: "27px", xl: "0px" }}
            >
              {[
                <Link href="/" _hover={{ color: "#FD8534" }}>
                  Home
                </Link>,
                <Link href="/about-us" _hover={{ color: "#FD8534" }}>
                  About Us
                </Link>,
                <Link href="/blog" _hover={{ color: "#FD8534" }}>
                  Blogs
                </Link>,
                <Link href="/contact-us" _hover={{ color: "#FD8534" }}>
                  Contact Us
                </Link>,
              ].map((item) => (
                <Text
                  key={item}
                  cursor="pointer"
                  color={activeItem === item ? "#FD8534" : "#666666"}
                  fontSize="14px"
                  fontStyle="normal"
                  fontWeight="500"
                  lineHeight="normal"
                  onClick={() => handleItemClick(item)}
                >
                  {item}
                </Text>
              ))}
            </VStack>
          </Box>
          {/* li-2 */}
          <Box>
            <Text
              cursor="pointer"
              color=" #FD8534"
              fontSize="16px"
              fontStyle="normal"
              fontWeight="500"
              lineHeight="normal"
            >
              Solutions
            </Text>
            <VStack
              spacing="10px"
              alignItems="start"
              paddingTop="27px"
              paddingBottom={{ base: "27px", xl: "0px" }}
            >
              {[
                <Link href="/akru-alts" _hover={{ color: "#FD8534" }}>
                  AKRU Alts. Custom Private Markets
                </Link>,
                <Link
                  href="/akru-investor-managment"
                  _hover={{ color: "#FD8534" }}
                >
                  AKRU IM
                </Link>,
                <Link href="/akru-admin" _hover={{ color: "#FD8534" }}>
                  AKRU Admin
                </Link>,
                <Link href="/akru-servicing" _hover={{ color: "#FD8534" }}>
                  AKRU Servicing
                </Link>,
                <Link href="/a-onfi-network" _hover={{ color: "#FD8534" }}>
                  A On-Fi Network
                </Link>,
                <Link href="/document-analyzer" _hover={{ color: "#FD8534" }}>
                  AKRU Document Analyzer
                </Link>,
                <Link href="/credit-unions" _hover={{ color: "#FD8534" }}>
                   AKRU for Credit Unions
                </Link>,
              ].map((item) => (
                <Text
                  key={item}
                  cursor="pointer"
                  color={activeItem === item ? "#FD8534" : "#666666"}
                  fontSize="14px"
                  fontStyle="normal"
                  fontWeight="500"
                  lineHeight="normal"
                  onClick={() => handleItemClick(item)}
                >
                  {item}
                </Text>
              ))}
            </VStack>
          </Box>
          {/* li-3 */}
          {/* <Box>
            <Text
              cursor="pointer"
              color=" #FD8534"
              fontSize="16px"
              fontStyle="normal"
              fontWeight="500"
              lineHeight="normal"
            >
              Contact
            </Text>
            <VStack
              spacing="10px"
              alignItems="start"
              paddingTop="27px"
              paddingBottom={{ base: "27px", xl: "0px" }}
            >
              {["Help Center", "Support"].map((item) => (
                <Text
                  key={item}
                  cursor="pointer"
                  _hover={{ color: "#FD8534" }}
                  color="#666666"
                  fontSize="14px"
                  fontStyle="normal"
                  fontWeight="500"
                  lineHeight="normal"
                  onClick={() => handleItemClick(item)}
                >
                  {item}
                </Text>
              ))}
            </VStack>
          </Box> */}
          <Box>
            {/* social-media */}
            <HStack width={{ base: "fit-content", xl: "100%" }}>
              {/* twitter */}
              <Flex
                cursor="pointer"
                alignItems="center"
                justifyContent="center"
                _hover={{ backgroundColor: "#FD8534" }}
                backgroundColor="#FFF3EB"
                width="50px"
                height="50px"
                borderRadius="5px"
                onMouseEnter={() => setIsHovered1(true)}
                onMouseLeave={() => setIsHovered1(false)}
                onClick={navigateOnClick("https://twitter.com/akru_co")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="14"
                  viewBox="0 0 17 14"
                  fill="none"
                >
                  <path
                    d="M17 1.66066C16.3748 1.94128 15.7033 2.1309 14.9972 2.2166C15.7257 1.77503 16.2707 1.08003 16.5306 0.261302C15.8461 0.673137 15.0971 0.963023 14.3159 1.11836C13.7906 0.550172 13.0948 0.173569 12.3366 0.0470186C11.5784 -0.0795316 10.8001 0.0510517 10.1226 0.418495C9.44514 0.785938 8.90638 1.36968 8.58996 2.0791C8.27354 2.78852 8.19718 3.58391 8.37272 4.3418C6.98589 4.27126 5.6292 3.90611 4.3907 3.27003C3.1522 2.63395 2.05956 1.74117 1.1837 0.649633C0.884216 1.17297 0.712014 1.77973 0.712014 2.42594C0.71168 3.00767 0.853094 3.58049 1.12371 4.09358C1.39432 4.60667 1.78577 5.04416 2.26332 5.36724C1.70949 5.34938 1.16788 5.19778 0.683564 4.92506V4.97056C0.683508 5.78647 0.962105 6.57726 1.47208 7.20877C1.98206 7.84027 2.69201 8.27359 3.48146 8.43519C2.96769 8.57605 2.42904 8.5968 1.90619 8.49587C2.12893 9.19791 2.5628 9.81181 3.14706 10.2516C3.73133 10.6915 4.43674 10.9352 5.16454 10.9487C3.92906 11.9312 2.40325 12.4642 0.832555 12.4618C0.554324 12.4619 0.276328 12.4455 0 12.4125C1.59434 13.451 3.45027 14.0021 5.34572 14C11.7621 14 15.2698 8.61647 15.2698 3.9474C15.2698 3.79571 15.266 3.6425 15.2593 3.49081C15.9416 2.99097 16.5305 2.37201 16.9985 1.66293L17 1.66066Z"
                    fill={isHovered1 ? "white" : "#FD8534"}
                  />
                </svg>
              </Flex>
              {/* facebook */}
              <Flex
                cursor="pointer"
                alignItems="center"
                justifyContent="center"
                _hover={{ backgroundColor: "#FD8534" }}
                backgroundColor="#FFF3EB"
                width="50px"
                height="50px"
                borderRadius="5px"
                onMouseEnter={() => setIsHovered2(true)}
                onMouseLeave={() => setIsHovered2(false)}
                onClick={navigateOnClick("https://www.facebook.com/Akruco/")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="8"
                  height="16"
                  viewBox="0 0 8 16"
                  fill="none"
                >
                  <path
                    d="M5.5 3H8V0H5.5C3.57 0 2 1.57 2 3.5V5H0V8H2V16H5V8H7.5L8 5H5V3.5C5 3.229 5.229 3 5.5 3Z"
                    fill={isHovered2 ? "white" : "#FD8534"}
                  />
                </svg>
              </Flex>
              {/* instagram */}
              <Flex
                cursor="pointer"
                alignItems="center"
                justifyContent="center"
                _hover={{ backgroundColor: "#FD8534" }}
                backgroundColor="#FFF3EB"
                width="50px"
                height="50px"
                borderRadius="5px"
                onMouseEnter={() => setIsHovered3(true)}
                onMouseLeave={() => setIsHovered3(false)}
                onClick={navigateOnClick("https://www.instagram.com/akru.co/")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M15.9485 4.72248C15.9395 4.05067 15.8135 3.38554 15.5762 2.75685C15.3704 2.22655 15.056 1.74494 14.6532 1.34279C14.2504 0.940648 13.768 0.626811 13.2368 0.421333C12.6151 0.188364 11.9584 0.0623939 11.2945 0.048786C10.4398 0.0106443 10.1688 0 7.99911 0C5.82941 0 5.55131 5.94791e-08 4.7028 0.048786C4.03924 0.0624939 3.38281 0.188463 2.76144 0.421333C2.23017 0.626668 1.74769 0.940454 1.34485 1.34262C0.942021 1.74478 0.627711 2.22646 0.422035 2.75685C0.188211 3.37699 0.062304 4.03247 0.0497557 4.69498C0.0115504 5.54917 0 5.81972 0 7.98581C0 10.1519 -6.6198e-09 10.4287 0.0497557 11.2766C0.0630831 11.9401 0.188361 12.5947 0.422035 13.2165C0.628057 13.7468 0.9426 14.2283 1.34557 14.6302C1.74853 15.0322 2.23107 15.3459 2.76233 15.5512C3.38199 15.7935 4.03854 15.9285 4.70369 15.9503C5.55931 15.9885 5.8303 16 8 16C10.1697 16 10.4478 16 11.2963 15.9503C11.9602 15.9373 12.6169 15.8116 13.2386 15.5787C13.7696 15.373 14.2519 15.059 14.6547 14.6569C15.0575 14.2548 15.3719 13.7733 15.578 13.2432C15.8116 12.6222 15.9369 11.9676 15.9502 11.3033C15.9884 10.4499 16 10.1794 16 8.01242C15.9982 5.84633 15.9982 5.57135 15.9485 4.72248ZM7.99378 12.0821C5.72457 12.0821 3.88627 10.2468 3.88627 7.98137C3.88627 5.71593 5.72457 3.8807 7.99378 3.8807C9.08316 3.8807 10.1279 4.31273 10.8982 5.08176C11.6685 5.85078 12.1013 6.89381 12.1013 7.98137C12.1013 9.06894 11.6685 10.112 10.8982 10.881C10.1279 11.65 9.08316 12.0821 7.99378 12.0821ZM12.2648 4.68522C12.139 4.68534 12.0144 4.66068 11.8981 4.61267C11.7818 4.56466 11.6762 4.49423 11.5872 4.40542C11.4983 4.3166 11.4277 4.21114 11.3796 4.09508C11.3316 3.97901 11.3069 3.85462 11.307 3.72902C11.307 3.6035 11.3317 3.47922 11.3798 3.36326C11.428 3.24731 11.4985 3.14194 11.5874 3.05319C11.6763 2.96444 11.7818 2.89404 11.898 2.84601C12.0141 2.79798 12.1386 2.77326 12.2643 2.77326C12.39 2.77326 12.5145 2.79798 12.6307 2.84601C12.7468 2.89404 12.8524 2.96444 12.9413 3.05319C13.0302 3.14194 13.1007 3.24731 13.1488 3.36326C13.1969 3.47922 13.2217 3.6035 13.2217 3.72902C13.2217 4.25768 12.7934 4.68522 12.2648 4.68522Z"
                    fill={isHovered3 ? "white" : "#FD8534"}
                  />
                </svg>
              </Flex>
              {/* link */}
              <Flex
                cursor="pointer"
                alignItems="center"
                justifyContent="center"
                _hover={{ backgroundColor: "#FD8534" }}
                backgroundColor="#FFF3EB"
                width="50px"
                height="50px"
                borderRadius="5px"
                onMouseEnter={() => setIsHovered4(true)}
                onMouseLeave={() => setIsHovered4(false)}
                onClick={navigateOnClick(
                  "https://www.linkedin.com/company/akruco/mycompany/?viewAsMember=true"
                )}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.9432 5.5752H8.9144V7.0552C9.3424 6.204 10.44 5.4392 12.0888 5.4392C15.2496 5.4392 16 7.1336 16 10.2424V16H12.8V10.9504C12.8 9.18 12.372 8.1816 11.2824 8.1816C9.7712 8.1816 9.1432 9.2576 9.1432 10.9496V16H5.9432V5.5752ZM0.456 15.864H3.656V5.4392H0.456V15.864ZM4.1144 2.04C4.11452 2.30822 4.06132 2.57379 3.95791 2.82127C3.85449 3.06875 3.70292 3.29321 3.512 3.4816C3.12512 3.8661 2.60145 4.08132 2.056 4.08C1.51151 4.07963 0.989049 3.86496 0.6016 3.4824C0.411369 3.29337 0.260309 3.06866 0.157075 2.82115C0.0538412 2.57363 0.000463305 2.30818 0 2.04C0 1.4984 0.216 0.98 0.6024 0.5976C0.989508 0.214527 1.51219 -0.000239369 2.0568 2.00212e-07C2.6024 2.00212e-07 3.1256 0.2152 3.512 0.5976C3.8976 0.98 4.1144 1.4984 4.1144 2.04Z"
                    fill={isHovered4 ? "white" : "#FD8534"}
                  />
                </svg>
              </Flex>
              {/* youtube */}
              <Flex
                cursor="pointer"
                alignItems="center"
                justifyContent="center"
                _hover={{ backgroundColor: "#FD8534" }}
                backgroundColor="#FFF3EB"
                width="50px"
                height="50px"
                borderRadius="5px"
                onMouseEnter={() => setIsHovered5(true)}
                onMouseLeave={() => setIsHovered5(false)}
                onClick={navigateOnClick(
                  "https://www.youtube.com/channel/UCQHC42tw1N2sBrJHPMyD3hQ"
                )}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="12"
                  viewBox="0 0 18 12"
                  fill="none"
                >
                  <path
                    d="M17.6219 1.88142C17.52 1.51796 17.3215 1.1889 17.0476 0.929224C16.7659 0.66156 16.4206 0.470095 16.0444 0.372898C14.6363 0.00176479 8.99509 0.00176487 8.99509 0.00176487C6.64333 -0.0249922 4.29214 0.0926922 1.9548 0.354154C1.57856 0.458531 1.23395 0.654275 0.951618 0.923975C0.674205 1.19089 0.473268 1.52004 0.368301 1.88067C0.11615 3.23906 -0.00636236 4.61832 0.00241587 5.99988C-0.00658131 7.3802 0.11563 8.75902 0.368301 10.1191C0.471019 10.4782 0.671206 10.8059 0.949368 11.0705C1.22753 11.3352 1.57392 11.5264 1.9548 11.6276C3.3816 11.998 8.99509 11.998 8.99509 11.998C11.3498 12.0248 13.704 11.9071 16.0444 11.6456C16.4206 11.5484 16.7659 11.3569 17.0476 11.0893C17.3214 10.8297 17.5197 10.5006 17.6211 10.1371C17.8799 8.77922 18.0057 7.39939 17.9968 6.01713C18.0162 4.62901 17.8906 3.24267 17.6219 1.88067V1.88142ZM7.20166 8.56707V3.43344L11.8952 6.00063L7.20166 8.56707Z"
                    fill={isHovered5 ? "white" : "#FD8534"}
                  />
                </svg>
              </Flex>
            </HStack>
            <Flex flexDirection="column" alignItems="start" paddingTop="27px">
              <Text
                textAlign="start"
                color=" #666"
                fontSize={{ base: "14px", xl: " 16px" }}
                fontStyle="normal"
                fontWeight=" 400"
                lineHeight="40px"
              >
                3825 Edwards Rd, Suite #103, Cincinnati, OH 45209.
              </Text>
              <Text
                textAlign="start"
                color=" #666"
                fontSize={{ base: "14px", xl: " 16px" }}
                fontStyle="normal"
                fontWeight=" 400"
                lineHeight="40px"
              >
                +1 888 966 AKRU (2578)
              </Text>
              <Text
                textAlign="start"
                color=" #666"
                fontSize={{ base: "14px", xl: " 16px" }}
                fontStyle="normal"
                fontWeight=" 400"
                lineHeight="40px"
              >
                info@akru.com
              </Text>
            </Flex>
          </Box>
        </Flex>
        <Divider
          marginY="50px"
          backgroundColor="#CCC"
          borderRadius="0 10px 10px 10px "
          border="1px solid #CCC"
        />
        <Flex justifyContent="center" paddingBottom="47px">
          <Text
            color="#666"
            fontSize="16px"
            fontStyle="normal"
            fontWeight="400"
            lineHeight="normal"
          >
            © <span style={{ color: "#FD8534" }}>2024 AKRU.</span> All
            rights reserved
          </Text>
        </Flex>
      </Box>
    </Box>
  );
};

export default Footer;
